import { useMemo } from 'react';
import type { IJobTask } from '../../../api';
import {
	BoldTextRender,
	DurationRender,
	LastUpdatedRender,
	TextRender,
} from '../../../components/TableV2/render';
import type { ExtendedDataTableColumn } from '../../../components/TableV2/types';

export const useColumns = (): ExtendedDataTableColumn<IJobTask>[] => {
	const columns: ExtendedDataTableColumn<IJobTask>[] = useMemo(
		() => [
			{
				titleLabel: 'Name',
				accessor: 'title',
				render: (record) => (
					<BoldTextRender<IJobTask> record={record} field={'title'} />
				),
			},
			{
				titleLabel: 'Description',
				accessor: 'description',
				render: (record) => (
					<TextRender<IJobTask> record={record} field={'description'} />
				),
			},
			{
				titleLabel: 'Started at',
				accessor: 'start_timestamp',
				render: (record) => (
					<LastUpdatedRender<IJobTask>
						record={record}
						field={'start_timestamp'}
					/>
				),
			},
			{
				titleLabel: 'Finished at',
				accessor: 'finish_timestamp',
				render: (record) => (
					<LastUpdatedRender<IJobTask>
						record={record}
						field={'finish_timestamp'}
					/>
				),
			},
			{
				titleLabel: 'Duration',
				accessor: 'duration',
				render: (record) => (
					<DurationRender<IJobTask>
						record={record}
						field1="start_timestamp"
						field2="finish_timestamp"
					/>
				),
			},
		],
		[]
	);

	return columns;
};
